import { bindEvents, lodash } from '../../../assets/js/helpers';

import ResizeController from '../../../assets/js/controller/resize';

import SplitText from '../../../assets/js/plugins/SplitText';

const selector = 'page-routing';

export default class RoutingPage {

	constructor(section) {
		this.el = {
			section,
			heading: section.querySelector(`.${selector}__heading`)
		};

		// class variable groups

		this.controllers = {
			resize: null
		};

		this.throttled = {
			resize: lodash.throttle(this.measureResize.bind(this), 500, { leading: false, trailing: true })
		};

		this.splits = [];

		// class variables

		// bind events to class scope
		this.events = bindEvents(this);

		// mosey
		this.init();
	}

	static get selector() {
		return selector;
	}

	// initialize

	init() {
		this.measure();
		this.addEventListeners();
	}

	// event listeners

	addEventListeners() {
		this.controllers.resize = ResizeController.set({
			update: () => { this.events._onWindowResize(); },
			resize: () => {}
		});
	}

	removeEventListeners() {
		ResizeController.clear(this.controllers.resize);
	}

	// listener methods

	_onWindowResize() {
		this.throttled.resize();
	}

	// animation controller events

	measure() {
		this.measureResize();
	}

	measureResize() {

		// split words into individual spans

		for (let i = 0; i < this.splits.length; i++) {
			const split = this.splits[i];
			split.revert();
		}

		this.splits = [];

		const split = new SplitText(this.el.heading, { type: 'words', linesClass: 'word' });
		this.splits.push(split);
	}

	// destroy

	destroy() {
		this.removeEventListeners();
	}

}
